import { useMemo } from "react"

import { BrowseTable } from "@/components/tables/BrowseTable"
import type { SimulationTableRowResource } from "@/types_api/backend/transport/simulated_conversations_keyset_response"

import { normalizeSimulationTableRow } from "../hooks/useRunsInfiniteQuery"
import { buildSimulationColumns } from "./RunsTableColumns"

const lookups = {
  agentNames: {},
  testSetNames: {},
  metricDisplayNames: {},
  metricRecordsById: {},
  personasById: {},
  getModelType: (value: string) =>
    value.replace("MODEL_TYPE_", "").replaceAll("_", " ").toLowerCase(),
  resolveCreator: (value: string | null | undefined) => value || "—",
}

export function SimulationSelectionTable({
  items,
  selectedId,
  onSelect,
  isLoading,
  hasMore,
  isFetchingMore,
  onLoadMore,
}: {
  items: SimulationTableRowResource[]
  selectedId?: string | null
  onSelect: (id: string) => void
  isLoading: boolean
  hasMore: boolean
  isFetchingMore: boolean
  onLoadMore: () => void
}) {
  const columns = useMemo(
    () =>
      buildSimulationColumns({
        columns: [
          { key: "status", label: "Status" },
          { key: "created", label: "Created" },
          { key: "modelType", label: "Simulator" },
          { key: "createdBy", label: "Created by" },
          { key: "runId", label: "Run ID" },
          { key: "simulationId", label: "ID" },
        ],
        tagsColumnWidth: 100,
        lookups,
      }).map((column) => ({ ...column, sortable: false })),
    [],
  )
  const rows = useMemo(() => items.map(normalizeSimulationTableRow), [items])
  return (
    <BrowseTable
      displayControls={false}
      aria-label="Simulated conversations table"
      data={rows}
      columns={columns}
      getRowId={(row) => row.simulation_output_id}
      activeRowId={selectedId}
      onRowClick={(row) => onSelect(row.simulation_output_id)}
      isLoading={isLoading}
      hasMore={hasMore}
      isFetchingMore={isFetchingMore}
      onLoadMore={onLoadMore}
      emptyState="No simulated conversations found"
      className="h-full"
    />
  )
}
